import React from 'react';
import { BookOpenIcon, CodeIcon, StorefrontIcon } from '@phosphor-icons/react';
import { SpeedTree } from '@unity/cloud-ui/icons/brands';
import DevOpsIcon from './icons/dev-ops-icon.png';
import LiveOpsIcon from './icons/live-ops-icon.png';
import MultiplayIcon from './icons/multiplay-icon.png';
import AnalyticsIcon from './icons/analytics-icon.png';
import AssetManagerIcon from './icons/asset-manager-icon.png';
import AssetTransformerIcon from './icons/asset-transformer.png';
import AdQualityIcon from './icons/ad-quality.svg';
import IronSourceIcon from './icons/ironsource.svg';
import LevelPlayIcon from './icons/levelplay.svg';
import UnityStudioIcon from './icons/unity-studio.png';
import TapJoyIcon from './icons/tapjoy-offerwall.svg';
import UnityMonetizationIcon from './icons/unity-ads-monetization.svg';
import UnityAdsUserAcquisitionIcon from './icons/unity-ads-user-acquisition.svg';
import UnityExchangeIcon from './icons/unity-exchange.svg';

export const HOME_PAGE_CONTENT = [
  {
    titleKey: 'home-page:unity-engine:title',
    description: 'home-page:unity-engine:description',
    cards: [
      {
        titleKey: 'home-page:unity-engine:card-1:title',
        description: 'home-page:unity-engine:card-1:description',
        href: 'https://docs.unity3d.com/Manual/index.html',
        icon: <BookOpenIcon size={20} />,
        iconColor: 'error.main',
        linkSections: [
          {
            titleKey: 'home-page:explore-topics',
            links: [
              {
                titleKey: 'home-page:unity-engine:card-1:link1:title',
                href: 'https://docs.unity3d.com/Manual/unity-editor.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link2:title',
                href: 'https://docs.unity3d.com/Manual/Unity2D.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link3:title',
                href: 'https://docs.unity3d.com/Manual/best-practice-guides.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link4:title',
                href: 'https://docs.unity3d.com/Manual/LightingOverview.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link5:title',
                href: 'https://docs.unity3d.com/Manual/render-pipelines.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link6:title',
                href: 'https://docs.unity3d.com/Manual/PhysicsSection.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link7:title',
                href: 'https://docs.unity3d.com/Manual/visual-effects.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link8:title',
                href: 'https://docs.unity3d.com/Manual/ScriptingSection.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link9:title',
                href: 'https://docs.unity3d.com/Manual/Audio.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link10:title',
                href: 'https://docs.unity3d.com/Manual/AnimationSection.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link11:title',
                href: 'https://docs.unity3d.com/Manual/UIToolkits.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link12:title',
                href: 'https://docs.unity3d.com/Manual/XR.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link13:title',
                href: 'https://docs.unity3d.com/Manual/VROverview.html',
              },
              {
                titleKey: 'home-page:unity-engine:card-1:link14:title',
                href: 'https://docs.unity3d.com/Manual/multiplayer.html',
              },
            ],
          },
        ],
      },
      {
        titleKey: 'home-page:unity-engine:card-2:title',
        description: 'home-page:unity-engine:card-2:description',
        href: 'https://docs.unity3d.com/ScriptReference/index.html',
        icon: <CodeIcon size={20} />,
        iconColor: 'info.main',
        linkSections: [
          {
            titleKey: 'home-page:explore-topics',
            links: [
              {
                title: 'Transform',
                href: 'https://docs.unity3d.com/ScriptReference/Transform.html',
              },
              {
                title: 'Object.Instantiate',
                href: 'https://docs.unity3d.com/ScriptReference/Object.Instantiate.html',
              },
              {
                title: 'Physics.Raycast',
                href: 'https://docs.unity3d.com/ScriptReference/Physics.Raycast.html',
              },
              {
                title: 'Vector3',
                href: 'https://docs.unity3d.com/ScriptReference/Vector3.html',
              },
              {
                title: 'Quaternion',
                href: 'https://docs.unity3d.com/ScriptReference/Quaternion.html',
              },
              {
                title: 'Random.Range',
                href: 'https://docs.unity3d.com/ScriptReference/Random.Range.html',
              },
              {
                title: 'Input',
                href: 'https://docs.unity3d.com/ScriptReference/Input.html',
              },
              {
                title: 'WaitForSeconds',
                href: 'https://docs.unity3d.com/ScriptReference/WaitForSeconds.html',
              },
              {
                title: 'MonoBehaviour',
                href: 'https://docs.unity3d.com/ScriptReference/MonoBehaviour.html',
              },
              {
                title: 'CharacterController',
                href: 'https://docs.unity3d.com/ScriptReference/CharacterController.Move.html',
              },
            ],
          },
        ],
      },
      {
        titleKey: 'home-page:unity-engine:card-3:title',
        description: 'home-page:unity-engine:card-3:description',
        href: 'https://docs.unity3d.com/Manual/AssetStore.html',
        icon: <StorefrontIcon size={20} />,
        iconColor: 'icons.pink',
      },
      {
        titleKey: 'home-page:creation-tools:card-2:title',
        description: 'home-page:creation-tools:card-2:description',
        href: 'https://docs.unity3d.com/speedtree-modeler/manual/',
        icon: <SpeedTree />,
        iconColor: 'action.active',
      },
    ],
  },
  {
    titleKey: 'home-page:unity-gaming-services:title',
    description: 'home-page:unity-gaming-services:description',
    cards: [
      {
        titleKey: 'home-page:unity-gaming-services:card-1:title',
        description: 'home-page:unity-gaming-services:card-1:description',
        href: '/devops',
        icon: <img src={DevOpsIcon.src} height={24} width={24} alt="" />,
        iconColor: null,
        displayLinksInColumns: true,
        linkSections: [
          {
            titleKey: 'home-page:explore-topics',
            links: [
              {
                titleKey: 'home-page:unity-gaming-services:card-1:link1:title',
                href: '/build-automation',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-1:link3:title',
                href: '/unity-version-control',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-1:link4:title',
                href: 'https://docs.unity3d.com/licensing/manual/index.html',
              },
            ],
          },
        ],
      },
      {
        titleKey: 'home-page:unity-gaming-services:card-2:title',
        description: 'home-page:unity-gaming-services:card-2:description',
        href: '',
        icon: <img src={LiveOpsIcon.src} height={24} width={24} alt="" />,
        iconColor: null,
        displayLinksInColumns: true,
        linkSections: [
          {
            titleKey: 'home-page:unity-gaming-services:card-2:link-section-1:title',
            links: [
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-1:link1:title',
                href: '/game-overrides',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-1:link2:title',
                href: '/push-notifications',
              },
            ],
          },
          {
            titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:title',
            links: [
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link1:title',
                href: '/ccd',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link2:title',
                href: '/authentication',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link3:title',
                href: '/remote-config',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link4:title',
                href: '/cloud-diagnostics',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link5:title',
                href: '/cloud-save',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link6:title',
                href: '/leaderboards',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link7:title',
                href: '/cloud-code',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-2:link-section-2:link9:title',
                href: '/economy',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-3:link3:title',
                href: '/iap',
              },
            ],
          },
        ],
      },
      {
        titleKey: 'home-page:unity-gaming-services:card-4:title',
        description: 'home-page:unity-gaming-services:card-4:description',
        href: 'https://docs.unity3d.com/Manual/multiplayer.html',
        icon: <img src={MultiplayIcon.src} height={24} width={24} alt="" />,
        iconColor: null,
        displayLinksInColumns: true,
        linkSections: [
          {
            titleKey: 'home-page:explore-topics',
            links: [
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-1:link1:title',
                href: '/multiplay-hosting',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-1:link2:title',
                href: '/lobby',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-1:link3:title',
                href: '/matchmaker',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-1:link4:title',
                href: '/friends',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-1:link5:title',
                href: '/vivox-unity',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-1:link6:title',
                href: '/moderation/overview',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-1:link7:title',
                href: '/relay',
              },
            ],
          },
          {
            titleKey: 'home-page:unity-gaming-services:card-4:link-section-2:title',
            links: [
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-2:link1:title',
                href: 'https://docs-multiplayer.unity3d.com/netcode/current/about',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-2:link2:title',
                href: 'https://docs-multiplayer.unity3d.com/transport/current/about',
              },
              {
                titleKey: 'home-page:unity-gaming-services:card-4:link-section-2:link3:title',
                href: 'https://docs.unity3d.com/Packages/com.unity.netcode@latest',
              },
            ],
          },
        ],
      },
      {
        titleKey: 'home-page:unity-gaming-services:card-5:title',
        description: 'home-page:unity-gaming-services:card-5:description',
        href: 'https://docs.unity.com/analytics/',
        icon: <img src={AnalyticsIcon.src} height={24} width={24} alt="" />,
        iconColor: null,
        displayLinksInColumns: false,
        linkSections: null,
      },
    ],
  },
  {
    titleKey: 'home-page:unity-grow:title',
    description: 'home-page:unity-grow:description',
    cards: [
      {
        titleKey: 'home-page:unity-grow:card-1:title',
        description: 'home-page:unity-grow:card-1:description',
        href: '/grow/levelplay',
        icon: <img src={LevelPlayIcon.src} height={24} width={24} alt="" />,
        iconColor: 'error.main',
      },
      {
        titleKey: 'home-page:unity-grow:card-2:title',
        description: 'home-page:unity-grow:card-2:description',
        href: '/grow/ad-quality',
        icon: <img src={AdQualityIcon.src} height={24} width={24} alt="" />,
      },
      {
        titleKey: 'home-page:unity-grow:card-3:title',
        description: 'home-page:unity-grow:card-3:description',
        href: '/grow/offerwall',
        icon: <img src={TapJoyIcon.src} height={24} width={24} alt="" />,
        iconColor: 'error.main',
      },
      {
        titleKey: 'home-page:unity-grow:card-4:title',
        description: 'home-page:unity-grow:card-4:description',
        href: '/grow/dashboard',
        icon: <img src={UnityMonetizationIcon.src} height={24} width={24} alt="" />,
        iconColor: 'error.main',
      },
      {
        titleKey: 'home-page:unity-grow:card-5:title',
        description: 'home-page:unity-grow:card-5:description',
        href: '/grow/ads',
        icon: <img src={UnityMonetizationIcon.src} height={24} width={24} alt="" />,
        iconColor: 'error.main',
      },
      {
        titleKey: 'home-page:unity-grow:card-6:title',
        description: 'home-page:unity-grow:card-6:description',
        href: '/grow/acquire',
        icon: <img src={UnityAdsUserAcquisitionIcon.src} height={24} width={24} alt="" />,
        iconColor: 'error.main',
      },
      {
        titleKey: 'home-page:unity-grow:card-7:title',
        description: 'home-page:unity-grow:card-7:description',
        href: '/grow/exchange',
        icon: <img src={UnityExchangeIcon.src} height={24} width={24} alt="" />,
        iconColor: 'error.main',
      },
      {
        titleKey: 'home-page:unity-grow:card-8:title',
        description: 'home-page:unity-grow:card-8:description',
        href: '/grow/is-ads',
        icon: <img src={IronSourceIcon.src} height={24} width={24} alt="" />,
        iconColor: 'error.main',
      },
    ],
  },
  {
    titleKey: 'home-page:unity-engine:industry:title',
    description: 'home-page:unity-engine:industry:description',
    cards: [
      {
        titleKey: 'home-page:unity-engine:card-4:title',
        description: 'home-page:unity-engine:card-4:description',
        href: '/cloud/asset-manager',
        icon: <img src={AssetManagerIcon.src} height={24} width={24} alt="" />,
        iconColor: null,
      },
      {
        titleKey: 'home-page:creation-tools:card-1:title',
        description: 'home-page:creation-tools:card-1:description',
        href: 'https://pixyz-software.com/documentations/',
        icon: <img src={AssetTransformerIcon.src} height={16} width={16} alt="" />,
        iconColor: 'action.active',
      },
      {
        titleKey: 'home-page:unity-engine:card-5:title',
        description: 'home-page:unity-engine:card-5:description',
        href: '/unity-studio',
        icon: <img src={UnityStudioIcon.src} height={24} width={24} alt="" />,
        iconColor: null,
      },
    ],
  },
] as const;
